(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = true;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.setAttribute('tabindex', '-1');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
          console.log('hover');
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  const menu = document.querySelector('[data-attribute-menu="menu_information"]');
  const target = document.querySelector('.header__icons');
  
  
console.log("menu" , menu)
if (menu) {
  // Check if screen width is at least 769px
  if (window.matchMedia("(min-width: 769px)").matches) {
    menu.style.display = 'block';
    target.prepend(menu);

    menu.addEventListener('mouseleave', () => {
      const overlay = document.querySelector('.overlay.js-overlay');
      console.log("menu", overlay)
      console.log('Mouse left the menu!');
      overlay.classList.remove("is-visible", "overlay--nav")
      menu.removeAttribute("open")
      menu.classList.remove("is-open")
      
      // menu.style.display = 'none'; 
    });

  }
}


  } catch(e) { console.error(e); }
})();
})();
